
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CartIcon from '../feature/CartIcon';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-40" style={{ borderBottom: '1px solid #C0C0C0' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span 
              className="text-2xl font-bold"
              style={{ 
                fontFamily: 'Cinzel Decorative, serif',
                color: '#0F3F2F'
              }}
            >
              DLUXMEN
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/catalogo" 
              className={`text-sm font-medium transition-colors duration-200 hover:text-green-800 ${
                isActive('/catalogo') ? 'text-green-800' : 'text-gray-700'
              }`}
              style={{ 
                fontFamily: 'Montserrat, sans-serif',
                color: isActive('/catalogo') ? '#0F3F2F' : '#C0C0C0'
              }}
            >
              Catálogo
            </Link>
            <Link 
              to="/masculino" 
              className={`text-sm font-medium transition-colors duration-200 hover:text-green-800 ${
                isActive('/masculino') ? 'text-green-800' : 'text-gray-700'
              }`}
              style={{ 
                fontFamily: 'Montserrat, sans-serif',
                color: isActive('/masculino') ? '#0F3F2F' : '#C0C0C0'
              }}
            >
              Masculino
            </Link>
            <Link 
              to="/acessorios" 
              className={`text-sm font-medium transition-colors duration-200 hover:text-green-800 ${
                isActive('/acessorios') ? 'text-green-800' : 'text-gray-700'
              }`}
              style={{ 
                fontFamily: 'Montserrat, sans-serif',
                color: isActive('/acessorios') ? '#0F3F2F' : '#C0C0C0'
              }}
            >
              Acessórios
            </Link>
            <Link 
              to="/agendamento" 
              className={`text-sm font-medium transition-colors duration-200 hover:text-green-800 ${
                isActive('/agendamento') ? 'text-green-800' : 'text-gray-700'
              }`}
              style={{ 
                fontFamily: 'Montserrat, sans-serif',
                color: isActive('/agendamento') ? '#0F3F2F' : '#C0C0C0'
              }}
            >
              Agendamento
            </Link>
            <Link 
              to="/contatos" 
              className={`text-sm font-medium transition-colors duration-200 hover:text-green-800 ${
                isActive('/contatos') ? 'text-green-800' : 'text-gray-700'
              }`}
              style={{ 
                fontFamily: 'Montserrat, sans-serif',
                color: isActive('/contatos') ? '#0F3F2F' : '#C0C0C0'
              }}
            >
              Contatos
            </Link>
          </nav>

          {/* Right Side Icons */}
          <div className="flex items-center space-x-4">
            <CartIcon />
            
            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500"
            >
              <span className="sr-only">Abrir menu</span>
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t" style={{ borderColor: '#C0C0C0' }}>
              <Link
                to="/catalogo"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#C0C0C0'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                Catálogo
              </Link>
              <Link
                to="/masculino"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#C0C0C0'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                Masculino
              </Link>
              <Link
                to="/acessorios"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#C0C0C0'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                Acessórios
              </Link>
              <Link
                to="/agendamento"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#C0C0C0'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                Agendamento
              </Link>
              <Link
                to="/contatos"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#C0C0C0'
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                Contatos
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
